import Vue from 'vue';
import AppConst from '../const/app.const';
// import Promise from 'pinkie-promise';
// eslint-disable-next-line import/no-cycle
import Native from './nativeProxy';
import env from './env';
import Store from '../store';

const CODE_MAPS = {
  101: '系统错误',
  102: '缺少参数',
  103: 'invalid token',
  104: '非法参数',
  801: '手机号无效',
  802: '亲，您已经参与过活动了，不要贪心哟！',
  803: '老用户',
  804: '已无优惠券',
  901: 'go back',
};

function encodeRequestData(data, needLogin) {
  return new Promise((resolve, reject) => {
    if (needLogin) {
      Native.getTokenAndKey().then((auth) => {
        // eslint-disable-next-line no-param-reassign
        data.token = auth.token;
        // eslint-disable-next-line no-param-reassign
        data.ticket = auth.ticket;
        resolve(data);
      }, reject);
    } else {
      resolve(data);
    }
  });
}

export default class Request {
  static base(type, data, options, needLogin) {
    // eslint-disable-next-line no-param-reassign
    options.autoLogin = options.autoLogin !== false;

    return new Promise((resolve, reject) => {
      const requestData = {
        // eslint-disable-next-line no-undef
        version: APP_VERSION,
        from: 'h5',
        systemCode: 63,
        platform: env.platformCode,
        ...data,
      };

      const requestOptions = {
        headers: {
          'Content-Type': 'text/plain;charset=utf-8',
        },
        timeout: 0,
        ...options,
      };

      const action = requestData.action || '';
      if (action.indexOf('&') !== -1) {
        requestData.action = action.substring(0, action.indexOf('&'));
      }
      encodeRequestData(requestData, needLogin).then((encodeData) => {
        const dataStr = JSON.stringify(encodeData);
        const apiServer = (options && options.apiServer) || AppConst.API;

        Vue.http[type](`${apiServer}?${action}`, dataStr, requestOptions)
          .then((res) => {
            const responseData = res.data;
            const { code } = responseData;
            if (code === 0) {
              resolve(responseData);
            } else if (code === 103 && needLogin) {
              Native.invalidToken().then(() => {
                // eslint-disable-next-line no-console
                console.log('invalidToken');
                const errObj = new Error('登录信息失效');
                errObj.response = res;
                reject(errObj);
                if (!(env.isEasyBikeApp || env.isHitchIndepApp) && options.autoLogin) {
                  if (Store.state.router) {
                    Store.state.router.replace({ name: 'login' });
                  }
                }
              });
            } else {
              let { msg } = responseData;
              let codeMsg = CODE_MAPS[code];
              if (!codeMsg) {
                codeMsg = `unknow code ${code}!`;
              }
              msg = msg || CODE_MAPS[code];
              // eslint-disable-next-line prefer-promise-reject-errors
              reject({
                message: msg,
                response: res,
                error: true,
              });
            }
          })
          .catch((res) => {
            // eslint-disable-next-line prefer-promise-reject-errors
            reject({
              message: '网络异常,请稍后重试',
              response: res,
              error: true,
              serverError: true,
            });
          });
      }, reject);
    });
  }

  static post(data, options, needLogin) {
    if (process.env.NODE_ENV !== 'pro') {
      // eslint-disable-next-line no-console
      console.log(data);
    }
    return Request.base('post', data, options || {}, needLogin);
  }

  static get(data, options) {
    return Request.base('get', data, options || {});
  }
}
